import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {DocumentFormatsSelectFilterComponent} from "./document-formats-select-filter.component";
import {SelectFilterModule} from "../../../../../../components/common/select-filter/select-filter.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SelectFilterModule
    ],
    declarations: [
        DocumentFormatsSelectFilterComponent,
    ],
    exports: [
        DocumentFormatsSelectFilterComponent
    ]
})
export class DocumentFormatsSelectFilterModule {}